app.factory('browser', [
    function (
    ) {
        return {
            isIe11: !!window.MSInputMethodContext && !!document.documentMode,
            isSafari: /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
            isAndroid: (navigator.userAgent.toLowerCase().indexOf('android') > -1),
            isIos: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
        };
    },
]);
